'use client'

import styles from '../jobs.module.scss'

export default function JobsLanding(): JSX.Element {
  return (
    <div className={styles.jobsLanding}>
      <div className={styles.jobsLandingContent}>
        <div className={styles.jobsLandingIcon}>
          <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0Z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
        </div>
        <h1 className={styles.jobsLandingTitle}>
          Find Your <span className={styles.jobsLandingTitleAccent}>Dream Job</span>
        </h1>
        <p className={styles.jobsLandingDescription}>
          Search thousands of job openings across the country. Find the perfect role that matches your skills and aspirations.
        </p>
      </div>
    </div>
  )
}
